export default {
      id: "menu__geoitem_add-usage",
      viewBox: "0 0 92.7 88.2",
      url: __webpack_public_path__ + "img/icons.svg#menu__geoitem_add",
      toString: function () {
        return this.url;
      }
    }